import { useEffect, useState } from 'react';
import { getVersion, isNil } from '../utils';

export const useAppVersion = () => {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    if (isNil(version)) {
      getVersion().then(setVersion);
    }
  }, [version]);

  return version;
};
